import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { useQueryLoading } from '@vue/apollo-composable';
import { useGetImpactGoalQuery, useCreateImpactMutation, useDeleteImpactMutation } from '~/types/types';
import { IMPACT_STRATEGY_CONCEPT_ID } from '~/constants/concepts';
import { useVentureId } from '~/functions/accounts';
import { canEditImpact, useRealUserIsIxAdmin } from '~/functions/impact-locking';
export default /*#__PURE__*/_defineComponent({
  __name: 'myImpactStrategy',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var ventureId = useVentureId();
    var _useGetImpactGoalQuer = useGetImpactGoalQuery({
        ventureId: ventureId.value
      }),
      result = _useGetImpactGoalQuer.result,
      refetch = _useGetImpactGoalQuer.refetch;
    var impactGoal = computed(function () {
      var _result$value;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getImpactGoal) || {};
    });
    var tocConceptId = IMPACT_STRATEGY_CONCEPT_ID;
    var tocImpact = computed(function () {
      var _impactGoal$value, _impactGoal$value$imp;
      return (_impactGoal$value = impactGoal.value) === null || _impactGoal$value === void 0 ? void 0 : (_impactGoal$value$imp = _impactGoal$value.impacts) === null || _impactGoal$value$imp === void 0 ? void 0 : _impactGoal$value$imp.find(function (i) {
        return i.conceptId === tocConceptId;
      });
    });
    var realUserIsIxAdmin = useRealUserIsIxAdmin();
    var tocImpactEditable = computed(function () {
      return canEditImpact(tocImpact.value, realUserIsIxAdmin.value);
    });
    var _useCreateImpactMutat = useCreateImpactMutation(),
      createImpact = _useCreateImpactMutat.mutate,
      onCreateDone = _useCreateImpactMutat.onDone;
    var _useDeleteImpactMutat = useDeleteImpactMutation(),
      deleteImpact = _useDeleteImpactMutat.mutate,
      onDeleteDone = _useDeleteImpactMutat.onDone;
    onCreateDone(function () {
      refetch();
    });
    onDeleteDone(function () {
      refetch();
    });
    var loading = useQueryLoading();
    var handleCreate = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _impactGoal$value2;
        var _window, _window$$nuxt;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!((_impactGoal$value2 = impactGoal.value) !== null && _impactGoal$value2 !== void 0 && _impactGoal$value2.id) || tocImpact.value)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              _context.next = 5;
              return createImpact({
                input: {
                  impactGoalId: impactGoal.value.id,
                  conceptId: tocConceptId,
                  hasFrozenOutcome: true
                }
              });
            case 5:
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](2);
              (_window = window) === null || _window === void 0 ? void 0 : (_window$$nuxt = _window.$nuxt) === null || _window$$nuxt === void 0 ? void 0 : _window$$nuxt.$emit('userError', {
                message: $i18n.t('impactGoal.myImpactStrategy.createError') || 'Failed to create impact strategy',
                color: 'red'
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 7]]);
      }));
      return function handleCreate() {
        return _ref.apply(this, arguments);
      };
    }();
    var handleDelete = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(dialog) {
        var _tocImpact$value;
        var _window2, _window2$$nuxt;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!((_tocImpact$value = tocImpact.value) !== null && _tocImpact$value !== void 0 && _tocImpact$value.id) || !tocImpactEditable.value)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return deleteImpact({
                impactId: tocImpact.value.id
              });
            case 5:
              dialog.value = false;
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](2);
              (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$$nuxt = _window2.$nuxt) === null || _window2$$nuxt === void 0 ? void 0 : _window2$$nuxt.$emit('userError', {
                message: $i18n.t('impactGoal.myImpactStrategy.deleteError') || 'Failed to delete impact strategy',
                color: 'red'
              });
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 8]]);
      }));
      return function handleDelete(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var editLink = computed(function () {
      var _tocImpact$value2;
      if (!((_tocImpact$value2 = tocImpact.value) !== null && _tocImpact$value2 !== void 0 && _tocImpact$value2.id)) return undefined;
      return {
        path: "/".concat(ventureId.value, "/impact/edit/impacts/").concat(tocImpact.value.id, "/impactStrategy")
      };
    });
    return {
      __sfc: true,
      $i18n: $i18n,
      ventureId: ventureId,
      result: result,
      refetch: refetch,
      impactGoal: impactGoal,
      tocConceptId: tocConceptId,
      tocImpact: tocImpact,
      realUserIsIxAdmin: realUserIsIxAdmin,
      tocImpactEditable: tocImpactEditable,
      createImpact: createImpact,
      onCreateDone: onCreateDone,
      deleteImpact: deleteImpact,
      onDeleteDone: onDeleteDone,
      loading: loading,
      handleCreate: handleCreate,
      handleDelete: handleDelete,
      editLink: editLink
    };
  }
});